import React, { useState } from "react";
import "./AboutContentStyles.css";

const sections = [
  {
    label: "Experience",
    content: (
      <div className="about-section">
        <h2 className="about-title-pink">Experiences</h2>
        <p>A timeline of roles that showcase how I have grown as a developer and contributor in the industry.</p>
        <div className="experience-grid">
          <div className="exp-card">
            <span className="exp-date">2025 - Present</span>
            <h3>Associate Manager - ICT Programmer</h3>
            <p>Fly Ace Holdings Inc.</p>
          </div>
          <div className="exp-card">
            <span className="exp-date">2024 - 2025</span>
            <h3>Senior Supervisor - ICT Programmer</h3>
            <p>Fly Ace Holdings Inc.</p>
          </div>
          <div className="exp-card">
            <span className="exp-date">2023 - 2024</span>
            <h3>Supervisor - ICT Programmer</h3>
            <p>Fly Ace Holdings Inc.</p>
          </div>
          <div className="exp-card">
            <span className="exp-date">2022 - 2023</span>
            <h3>ICT Systems Associate Manager</h3>
            <p>TVCXpress / Telos Media Works Inc.</p>
          </div>
          <div className="exp-card">
            <span className="exp-date">2019 - 2022</span>
            <h3>Full-stack Systems Developer</h3>
            <p>Digital Data / 5119 Technologies Corp.</p>
          </div>
        </div>
      </div>
    ),
  },
  {
    label: "Education",
    content: (
      <div className="about-section">
        <h2 className="about-title-pink">Education</h2>
        <h2 className="about-title">Bachelor of Science in Computer Engineering</h2>
        <h4>San Sebastian College – Recoletos de Cavite</h4>
        <p>A well-rounded student who balanced academics with active participation in school organizations. Served as a varsity volleyball player while contributing to FORCES, the official organization for all engineering students, first as a graphics artist and later as Vice President for External Affairs. Also an active member of CGATES, the organization dedicated to Computer Engineering students, supporting various academic and extracurricular initiatives.</p>
      </div>
    ),
  },
  {
    label: "Skills",
    content: (
      <div className="about-section">
        <h2 className="about-title-pink">Skills</h2>
        <p>Equipped with a diverse technical skill set gained through academic projects, internships, and professional experiences. Skilled in software development, troubleshooting, and using various development tools and platforms.</p>
        <div className="experience-grid">
          <div className="exp-card">
            <h3 className="about-title">Programming Languages</h3>
            <p>VB, C#, HTML, CSS, JS, Python, SQL, MongoDB</p>
          </div>
          <div className="exp-card">
            <h3 className="about-title">Applications/Platforms</h3>
            <p>MS Office, VS Code, Visual Studio, VB6, PyCharm, SSMS, Laragon</p>
          </div>
          <div className="exp-card">
            <h3 className="about-title">Hardware</h3>
            <p>Raspberry Pi, PC/Mobile Troubleshooting, Network Management, CCTV</p>
          </div>
          <div className="exp-card">
            <h3 className="about-title">Operating Systems</h3>
            <p>Windows, Android</p>
          </div>
        </div>
      </div>
    ),
  },
  {
    label: "About me",
    content: (
      <div className="about-section">
        <h2 className="about-title-pink">About me</h2>
        <p>A Computer Engineering graduate with over 6 years of hands-on experience in software development, project execution, and team collaboration. Proficient in both front-end and back-end technologies, with a strong command of programming languages, database systems, and modern development frameworks. Known for delivering scalable and maintainable solutions, I consistently bring ideas to life through clean code and efficient system designs.</p>
        <br/>
        <p>Throughout my career, I’ve contributed to various stages of the software development lifecycle — from requirement gathering and system analysis to deployment and support. My ability to lead and collaborate across departments ensures smooth project flow and alignment with business goals. Adaptable, results-driven, and passionate about continuous improvement, I aim to create meaningful impact through technology.</p>
      </div>
    ),
  },
];

const AboutContent = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <div className="about2">
      <div className="about2-left">
        <h1>Get to know me.</h1>
        <div className="about2-nav">
          {sections.map((section, idx) => (
            <button
              key={section.label}
              className={`about2-btn${activeIndex === idx ? " active" : ""}`}
              onClick={() => setActiveIndex(idx)}
            >
              {section.label}
            </button>
          ))}
        </div>
      </div>
      <div className="about2-right">
        {sections[activeIndex].content}
      </div>
    </div>
  );
};

export default AboutContent;